import React from 'react';
import styled from 'styled-components';

// Mock mobile detection for demo
const isMobile = window.innerWidth < 768;

export const TeacherStatCard = ({ title, value, icon, onClick, style, color = '#36348E' }) => {
  return (
    <div className={`col-lg-3 col-md-6 ${isMobile ? 'mt-0' : ''}`} style={{paddingRight: ".50rem", paddingLeft: ".50rem"}}>
      <StyledWrapper 
        onClick={onClick} 
        style={style} 
        accentColor={color}
      >
        <div className="card blueborder">
          {/* Mesh gradient background */}
          <div className="mesh-gradient" />
          
          {/* Glass morphism layer */}
          <div className="glass-layer" />
          
          <div className="content" 
            style={{
              flexDirection: isMobile ? "row" : "column", 
              justifyContent: isMobile ? "space-between" : "center",
              alignItems: "center",
              padding: isMobile ? "20px" : "28px",
              width: "100%",
              gap: isMobile ? "15px" : "20px"
            }}
          >
            <IconWrapper opacity={0.5} accentColor={color}>
              <i className={icon}></i>
            </IconWrapper>
            
            <div className="info">
              <div className="value-container">
                <h3 className="newfont value">{value}</h3>
              </div>
              <h5 className="newfont label">{title}</h5>
              <div className="stats-bar">
                <div className="stats-fill" />
              </div>
            </div>
          </div>
          
          {/* Corner decorations */}
          <svg className="corner-svg top-left" viewBox="0 0 50 50">
            <path d="M 0 0 L 50 0 L 0 50 Z" fill="currentColor" opacity="0.1"/>
          </svg>
          <svg className="corner-svg bottom-right" viewBox="0 0 50 50">
            <path d="M 50 50 L 0 50 L 50 0 Z" fill="currentColor" opacity="0.1"/>
          </svg>
        </div>
      </StyledWrapper>
    </div>
  );
};

const StyledWrapper = styled.div`
  .card {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: ${isMobile ? '120px' : '220px'};
    cursor: ${props => props.onClick ? 'pointer' : 'default'};
    // background: linear-gradient(135deg, 
    //   ${props => props.accentColor}15 0%, 
    //   ${props => props.accentColor}08 50%,
    //   ${props => props.accentColor}20 100%
    // );
  }

  /* Mesh gradient background */
  .mesh-gradient {
    position: absolute;
    inset: 0;
    // background: 
    //   radial-gradient(circle at 20% 80%, ${props => props.accentColor}20 0%, transparent 50%),
    //   radial-gradient(circle at 80% 20%, ${props => props.accentColor}15 0%, transparent 50%),
    //   radial-gradient(circle at 40% 40%, ${props => props.accentColor}10 0%, transparent 50%);
    z-index: 1;
  }

  /* Glass morphism layer */
  .glass-layer {
    position: absolute;
    inset: 0px;
    // background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 10px;
    // border: 1px solid ${props => props.accentColor};
    z-index: 2;
    // box-shadow: 
    //   inset 0 0 20px rgba(255, 255, 255, 0.1),
    //   0 8px 32px rgba(0, 0, 0, 0.1);
  }

  /* Content */
  .content {
    position: relative;
    z-index: 5;
    display: flex;
  }

  /* Corner SVG decorations */
  .corner-svg {
    position: absolute;
    width: 50px;
    height: 50px;
    color: ${props => props.accentColor};
    opacity: 0.1;
    z-index: 3;
    
    &.top-left {
      top: 0;
      left: 0;
    }
    
    &.bottom-right {
      bottom: 0;
      right: 0;
      transform: rotate(180deg);
    }
  }

  /* Info section */
  .info {
    text-align: ${isMobile ? 'left' : 'center'};
    position: relative;
  }

  .value-container {
    position: relative;
    display: inline-block;
  }

  .value {
    font-size: 3rem;
    font-weight: 800;
    margin: 0;
    letter-spacing: -0.03em;
    background: rgb(108, 99, 255);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    margin-bottom: 0.5rem;
    filter: drop-shadow(0 2px 4px ${props => props.accentColor}40);
  }

  .value-underline {
    height: 3px;
    background: linear-gradient(90deg, 
      transparent,
      ${props => props.accentColor},
      transparent
    );
    margin: 8px auto;
    width: 60%;
    border-radius: 2px;
  }

  .label {
    font-size: 0.9rem;
    font-weight: 700;
    color: black;
    margin: 0;
    line-height: 1.4;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 12px;
    opacity: 1;
  }

  .stats-bar {
    width: 100%;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    overflow: hidden;
    margin-top: 8px;
  }

  .stats-fill {
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, 
      ${props => props.accentColor}aa,
      ${props => props.accentColor}
    );
    border-radius: 2px;
  }
`;

const IconWrapper = styled.div`
  position: relative;
  font-size: 40px;
  color: white;
  background: linear-gradient(135deg, rgb(108 99 255 / 30%) 0%, rgb(174 186 255 / 90%) 100%);
  padding: 22px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  box-shadow: 
    0 10px 30px -10px ${props => props.accentColor}60,
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  
  i {
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }
`;
